/**
 * Pre-compiled pt-BR messages for PasswordInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { hide: `Ocultar senha`, show: `Mostrar senha` };
